import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.fido-add', {
        url: '/add-fido-tokens',
        // component: 'addFidoTokens'
        views: {
            '@company': 'addFidoTokens'
        }
    })
}





// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/fido-add/fido-add.state.js